module.exports = __webpack_public_path__ + "img/earn-count-btn-3.13b25301.png";